import * as React from 'react'
import classNames from 'classnames'
import { Button } from '../button'
import './accordion.scss'

interface IProps {
  className?: string
  buttonClassName?: string
  labelShow?: string
  labelHide?: string
  content?: 'above' | 'below' // 'below' is the default behaviour
  children: React.ReactNode
}

interface IState {
  active: boolean
  height: number
}

export class Accordion extends React.Component<IProps, IState> {
  state: IState = {
    active: false,
    height: 0
  }
  contentRef: React.RefObject<HTMLDivElement> = React.createRef()

  componentDidMount(): void {
    this.setAccordion()
  }

  componentDidUpdate(prevProps: IProps, prevState: IState): void {
    if (this.state.active !== prevState.active) {
      this.setAccordion()
    }
  }

  toggleAccordion = (): void => {
    this.setState({
      active: !this.state.active
    })
  }

  setAccordion = (): void => {
    const height: number = this.state.active
      ? this.contentRef.current.clientHeight
      : 0

    this.setState({
      height
    })
  }

  innerContent = (): JSX.Element => {
    return (
      <div className="accordion__inner" style={{ height: `${this.state.height}px` }}>
        <div className="accordion__content" ref={this.contentRef}>
          {this.props.children}
        </div>
      </div>
    )
  }

  renderLabel = (): string => {
    return this.state.active
      ? (this.props.labelHide || 'Hide')
      : (this.props.labelShow || 'Show')
  }

  render(): React.ReactNode {
    const classes: string = classNames(
      'accordion',
      this.props.className,
      { 'accordion--active': this.state.active }
    )

    const buttonClasses: string = classNames(
      'accordion__trigger',
      { [this.props.buttonClassName]: this.props.buttonClassName }
    )

    return (
      <div className={classes}>
        <div className={`accordion__header accordion__header--${this.props.content || 'below'}`}>
          <div className="container container--compact-mobile">
            <Button
              class={buttonClasses}
              style="pill-outline"
              display="slim"
              iconRight="down"
              onClick={this.toggleAccordion}
            >
              {this.renderLabel()}
            </Button>

            <hr className="accordion__divider" />
          </div>
        </div>

        <div className="accordion__inner" style={{ height: `${this.state.height}px` }}>
          <div className="accordion__content" ref={this.contentRef}>
            {this.props.children}
          </div>
        </div>
      </div>
    )
  }
}
